import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BarGraph from "../../../general/BarGraph";
import styles from "./ObraL3.module.css";

function ObraL3({ distrito }) {
  const [assistenciaTecnica, setAssistenciaTecnica] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [assistenciaTecnica] =
          await Promise.all([
            Api.getAssistenciaTecnica(distrito),
          ]);
        setAssistenciaTecnica(Functions.buildBarGraph(assistenciaTecnica));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);
  const mockupFunction = (value) => {
    value = value + 1;
  };

  return (
    <div className={styles.obraL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {assistenciaTecnica && (
            <BarGraph
              data={assistenciaTecnica}
              text="USO DE ASSISTÊNCIA TÉCNICA"
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ObraL3;
